// askSmart-ui/src/pages/MapleCoin/components/AccountCard.tsx
// One account in the list shown when a customer holds more than one.
import { ChevronRight } from 'lucide-react';
import { AccountOverview } from '../types';
import { CURRENCIES, formatMoney } from '../money';
import Flag from './Flag';

export default function AccountCard({ account, onOpen }: { account: AccountOverview; onOpen: () => void }) {
  const { currency, accountNumber } = account;
  // What can be used now: the balance less anything on hold.
  const spendable = account.spendableMinor ?? account.availableMinor;
  return (
    <button type="button" className="mc-account" onClick={onOpen}>
      <div className="mc-account-head">
        <Flag currency={currency} />
        <div>
          <div className="mc-account-code">{currency} · {accountNumber}</div>
          <div className="mc-account-name">{CURRENCIES[currency].name}</div>
        </div>
      </div>
      <div className="mc-account-balance">{formatMoney(spendable, currency)}</div>
      <span className="mc-account-link">
        View account <ChevronRight size={16} />
      </span>
    </button>
  );
}
